import { getUserCountry } from '../services/location.service';

const getCookie = (cName, cookieContext) => {
  let ca = '';
  if (typeof window !== 'undefined') {
    ca = document?.cookie.split(';');
  } else {
    ca = cookieContext?.split(';');
  }
  let cookieValue = '';
  ca.forEach((cookie) => {
    const c = cookie.replace(/^\s+|\s+$/gm, '');
    if (c.indexOf(cName) !== -1) cookieValue = c.substring(cName.length + 1, c.length);
  });

  return cookieValue;
};

const getUserCountryCookie = async (cookieContext = undefined) => {
  let countryCode = 'US';
  // if en-us, then first attempt at getting the
  // cookie "userCountryCode"
  if (cookieContext && getCookie('userCountryCode', cookieContext)) {
    countryCode = getCookie('userCountryCode', cookieContext);
    console.log('found country code in cookie, userCountryCode :: ', countryCode);

    return countryCode;
  }

  // Then try other cookie
  // cookie "cdn-user-cc"
  if (cookieContext && getCookie('cdn-user-cc', cookieContext)) {
    countryCode = getCookie('cdn-user-cc', cookieContext);
    console.log('found country code in cookie, cdn-user-cc :: ', countryCode);
    return countryCode;
  }

  // If not found in cookie, get IP location

  try {
    // const locationService = new LocationService();
    const userCountry = await getUserCountry();
    console.log('from api call :: ', userCountry);
    return userCountry;
  } catch (e) {
    console.error('Detecting IP location', e);
    return 'US';
  }
};

export default getUserCountryCookie;
